@if (item) {
  <div [style]="'background-color :'+ item.background" class="item">
    <cx-media [container]="item.image"></cx-media>
    @if (!isGrid) {
      <div class="content-items">
        <div [className]="'h3-component'">{{item.title}}</div>
        <div [innerHTML]="!item?.longDescription ? item?.description : item?.longDescription"></div>
        @if (item?.urlLink?.url) {
          <a [routerLink]="item?.urlLink?.url"> {{item?.urlLink?.linkName}}</a>
        }
      </div>
    }
  </div>
}